import { useCallback } from 'react';
import { useAnimate, useReducedMotion } from 'motion/react';

/**
 * Small comic screen shake (SATILDI!, VS impact). Attach `ref` to the element to shake and call
 * `shake()`; `strength` scales the offsets. No-op under reduced motion.
 */
export function useShake<T extends HTMLElement = HTMLDivElement>() {
  const [scope, animate] = useAnimate<T>();
  const reduce = useReducedMotion();
  const shake = useCallback(
    (strength = 1) => {
      if (reduce || !scope.current) return;
      const s = strength;
      void animate(
        scope.current,
        {
          x: [0, -9 * s, 8 * s, -6 * s, 4 * s, -2 * s, 0],
          y: [0, 4 * s, -3 * s, 2 * s, -1 * s, 0, 0],
          rotate: [0, -0.6 * s, 0.5 * s, -0.3 * s, 0, 0, 0],
        },
        { duration: 0.42, ease: 'easeOut' },
      );
    },
    [animate, scope, reduce],
  );
  return { ref: scope, shake };
}
